<!-- ============================================================== -->
<!-- sidebar -->
<!-- ============================================================== -->
<nav class="sidebar-nav" appAccordion>
    <ng-container *ngFor="let section of sections">

    <!-- Each section is a panel. The open one is tinted with an accent bar on
         the left so the group you are in stands out from the closed headers.
         The nameless section (Dashboard) has no header and stays flat. -->
    <div class="sidebar-section"
         [class.is-open]="!!section.name && isSectionOpen(section.name)"
         [class.sidebar-section--plain]="!section.name">

        <!-- Section header (click to expand / collapse). The nameless section
             holds the links above every header (Dashboard) and is always shown. -->
        <button type="button"
            class="saperator text-muted"
            *ngIf="section.name"
            [class.is-open]="isSectionOpen(section.name)"
            [attr.aria-expanded]="isSectionOpen(section.name)"
            (click)="toggleSection(section.name)">
            <span class="saperator-label">{{ section.name | translate }}</span>
            <mat-icon class="saperator-caret">keyboard_arrow_down</mat-icon>
        </button>

    <ng-container *ngIf="!section.name || isSectionOpen(section.name)">
    <div class="sidebar-section__items">
    <ng-container *ngFor="let menuitem of section.items">

        <!-- Sub-heading inside a section -->
        <div class="sidebar-subheader" *ngIf="menuitem.type === 'subheader'">{{ menuitem.name | translate }}</div>

        <!-- Simple link -->
        <a class="sidebar-link"
            [class.sidebar-link--danger]="menuitem.danger"
            routerLinkActive="selected"
            [routerLinkActiveOptions]="{ exact: menuitem.exact || false }"
            [routerLink]="'/' + menuitem.state"
            [matTooltip]="menuitem.name | translate" matTooltipPosition="right"
            (click)="scrollToTop()"
            *ngIf="menuitem.type === 'link'">
            <mat-icon class="sidebar-icon">{{ menuitem.icon }}</mat-icon>
            <span class="sidebar-label">{{ menuitem.name | translate }}</span>
            <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
        </a>

        <!-- External link -->
        <a class="sidebar-link"
            appAccordionLink appAccordionToggle
            [group]="menuitem.state"
            routerLinkActive="selected"
            href="{{menuitem.state}}"
            [matTooltip]="menuitem.name | translate" matTooltipPosition="right"
            *ngIf="menuitem.type === 'extLink'">
            <mat-icon class="sidebar-icon">{{ menuitem.icon }}</mat-icon>
            <span class="sidebar-label">{{ menuitem.name | translate }}</span>
            <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
        </a>

        <!-- External tab link -->
        <a class="sidebar-link"
            appAccordionLink appAccordionToggle
            [group]="menuitem.state"
            routerLinkActive="selected"
            href="{{menuitem.state}}"
            target="_blank"
            [matTooltip]="menuitem.name | translate" matTooltipPosition="right"
            *ngIf="menuitem.type === 'extTabLink'">
            <mat-icon class="sidebar-icon">{{ menuitem.icon }}</mat-icon>
            <span class="sidebar-label">{{ menuitem.name | translate }}</span>
            <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
        </a>

        <!-- Sub menu parent trigger. `sub-parent` lets the expanded state be
             styled as a light tint, so the solid fill stays reserved for the
             page you are actually on. -->
        <a class="sidebar-link sub-parent"
            appAccordionLink appAccordionToggle
            [group]="menuitem.state"
            routerLinkActive="selected"
            href="javascript:;"
            [matTooltip]="menuitem.name | translate" matTooltipPosition="right"
            *ngIf="menuitem.type === 'sub'">
            <mat-icon class="sidebar-icon">{{ menuitem.icon }}</mat-icon>
            <span class="sidebar-label">{{ menuitem.name | translate }}</span>
            <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
            <mat-icon class="dd-icon">keyboard_arrow_down</mat-icon>
        </a>

        <!-- Sub menu children -->
        <div class="sub-item" *ngIf="menuitem.type === 'sub'">
            <ng-container *ngFor="let childitem of menuitem.children; let j=index; let i=childitem">
                <a class="sidebar-link sub-link"
                    [routerLink]="['/', menuitem.state, childitem.state]"
                    [matTooltip]="childitem.name | translate" matTooltipPosition="right"
                    routerLinkActive="selected"
                    (click)="itemSelect[i]=j"
                    *ngIf="childitem.type === 'link'">
                    {{ childitem.name | translate }}
                </a>
                <a class="sidebar-link sub-link"
                    appAccordionToggle
                    href="javascript: void(0);"
                    [matTooltip]="childitem.name | translate" matTooltipPosition="right"
                    (click)="itemSelect[i]=j"
                    [ngClass]="j==itemSelect[i]? 'selected' : ''"
                    *ngIf="childitem.type === 'subchild'">
                    <span class="sidebar-label">{{ childitem.name | translate }}</span>
                    <mat-icon class="dd-icon">keyboard_arrow_down</mat-icon>
                </a>
                <div class="child-sub-item" *ngIf="childitem.type === 'subchild'">
                    <a class="sidebar-link sub-link"
                        *ngFor="let child of childitem.subchildren"
                        [matTooltip]="child.name | translate" matTooltipPosition="right"
                        [routerLink]="['/', menuitem.state, childitem.state, child.state]"
                        routerLinkActive="selected">
                        {{ child.name | translate }}
                    </a>
                </div>
            </ng-container>
        </div>

    </ng-container>
    </div>
    </ng-container>
    </div>
    </ng-container>
</nav>
